import { takeEvery, put, fork } from "redux-saga/effects";
import * as actions from "../actions/CreateMultiplePMActions";
import * as api from "../../api/CreateMultiplePMApi";
import { showErrorSnackbar, showSuccessSnackbar } from "../actions/SnackbarActions";
import { setBackdrop, resetBackdrop } from "../actions/BackdropActions";

function* getAllEquipmentsByArea(action) {
    try {
        const result = yield api.getAllEquipmentsByArea(action.payload);
        yield put(actions.setAllEquipmentsByAreaGroup(result));
    } catch (error) {
        yield put(showErrorSnackbar(error, "error"));
    }
    yield put(setBackdrop());
}

function* postCreateMultiplePM(action) {
    yield put(resetBackdrop());
    try {
        const { data } = yield api.createMultiplePM(action.payload);
        yield put(actions.setCreateMultiplePM(data || undefined));
        yield put(showSuccessSnackbar(data.message));
    } catch (error) {
        yield put(showErrorSnackbar(error, "error"));
    }
    yield put(setBackdrop());
}

function* watchAll() {
    yield takeEvery(actions.Types.GET_ALL_EQUIPMENT_BY_AREA_GROUP, getAllEquipmentsByArea);
    yield takeEvery(actions.Types.POST_CREATE_MULTIPLE_PM, postCreateMultiplePM);
}

const CreateMultiplePMSaga = [fork(watchAll)];

export default CreateMultiplePMSaga;
